module.exports = __webpack_public_path__ + "static/media/instagramIcon.580f8041.png";